import * as THREE from 'three';

import AbstractObject from '../../misc/object';
import Scene from '@scene';
import {
  //getDotsOnSide,
  getEndpoints,
  // getTriangle,
  //removeDuplicatesDots,
  // resizeTriangle,
  // triangleMiddle,
  // triangleSides,
  //toRadians,
  unitTransform,
  addDistanceLabel
} from '@services/helper.service';

import Screw from './screw';
import Panel from '../panel';
import Arrow from '../arrow';
import { defaultUnits } from '@config';
import TextLabel from '../text';
import { HTMLEditableLabel } from '../html-label';
import { LabelsPadding } from '../ground';
import Line from '../line';
import DraggableObject from '../draggable-object';

export default class ScrewGroup extends AbstractObject {

  static formation = {
    NOT_SET: 'NOT_SET',
    TRIANGLE: 'TRIANGLE',
    FILLED_SQUARE: 'FILLED_SQUARE',
    EMPTY_SQUARE: 'EMPTY_SQUARE',
    ROUNDED_EDGE_QUARE: 'ROUNDED_EDGE_QUARE',
    CIRCLE: 'CIRCLE',
    BEND: 'BEND'
  };

  constructor(options) {
    super(options);

    this._screwList = [];

    if (this.options.custom.active && this.options.custom.positions.length) {
      this._screwCoordinates = this.options.custom.positions;
      setScrewPositions(this.options.custom.positions);
    } else {
      this._screwCoordinates = this.getScrewsCoords();
      setScrewPositions(this._screwCoordinates);
    }


    if (this.options.formation !== ScrewGroup.formation.BEND) {
      this.generateScrews(this._screwCoordinates, this.options);
    } else if (this.options.formation  === ScrewGroup.formation.BEND) {
      this.generateScrewsForBend(this._screwCoordinates);
    }
  }

  get isCustom() {
    return this.options.custom.allow;
  }

  get screws() {
    return this._screwList;
  }

  get screwCoordinates() {
    return this._screwCoordinates;
  }

  generateScrewsForBend(coords) {
    // let counter = 0;
    if (coords.length) {
      // const screwLayer = new THREE.Object3D();
      // const screwEndpoints = getEndpoints(coords, true);

      coords.forEach((item, setIndex) => {
        item.forEach((position, i) => {
          const type = this.options.types.find(item => item.index === i + 1);

          const screw = new Screw({
            radius: this.options.radius,
            heightType: this.options.heightType,
            type: type && type.type,
            number: !setIndex ? this.options.forBend.sideCount + (i + 1) : (i + 1),
            height: parseFloat(this.options.panel.depth) + Screw.minSize
          });

          if (setIndex) {
            // if (this.options.panel.dy && this.options.panel.dy.isCustom) {
            //   position.x += screwEndpoints.side.bottom.z - this.options.panel.height / 2 + this.options.panel.dy.value;
            // } else {
            //   position.x += screw.size.height / 2;
            // }
            screw.mesh.rotation.y = Math.PI / 2;
          } else {
            position.z += (this.options.panel.lyh && this.options.panel.lyh.active ? 
                this.options.panel.lyh.value : this.options.panel.topHeight) /2;
            position.x = (position.x + this.options.panel.height / 2) - parseFloat(this.options.panel.depth) + Screw.minSize;
          }

          screw.setPosition(position);

          if (setIndex) {
            screw.numberLabel.position.set(-position.y, position.z, -position.x - screw.size.radius / 2 - 1);
          }

          this.object.addObject(screw);

          this._screwList.push(screw);
        });
      });

      // if (this.options.panel.dy) {
      //   if (this.options.panel.dy.isCustom) {
      //     screwLayer.position.z = -(screwEndpoints.side.bottom.z - this.options.panel.height / 2 + this.options.panel.dy.value);
      //   } else {
      //     this.options.panel.dy.value = Math.abs(screwEndpoints.bottom.z - this.options.panel.height / 2);
      //   }
      // }
    }
  }

  generateScrews(coords) {
    const { radius, heightType, types, heightOffset } = this.options;

    if (coords && coords.length) {
      const screwLayer = new THREE.Object3D();
      this.object.addMesh(screwLayer);

      for (let i = 0; i < coords.length; i++) {
        const type = types.find(item => item.index === i + 1);

        let height = parseFloat(this.options.panel.depth);

        if (this.options.heightType === Screw.types.height.INDENTED) {
          height += this.options.panel.standOff.value;
        }

        const screw = new Screw({
          radius: radius,
          heightType: heightType,
          type: type && type.type,
          color: 0x000000,
          number: i + 1,
          height: height,
          heightOffset: heightOffset || 0
        });

        coords[i].x = Screw.minSize - height / 2;
        
        screw.setPosition(coords[i]);
        screw.mesh.position.x += (heightOffset || 0) / 2;

        screwLayer.add(screw.mesh);

        this._screwList.push(screw);
      }
      // TODO: Hot fix
      // const screwEndpoints = getEndpoints(this.screwCoordinates);
      // if (this.options.dy) {
      //   if (this.options.dy.isCustom) {
      //     screwLayer.position.z = -(screwEndpoints.bottom.z - this.options.panel.height / 2 + this.options.dy.value);
      //   } else {
      //     this.options.dy.value = Math.abs(screwEndpoints.bottom.z - this.options.panel.height / 2);
      //   }
      // }
    }
  }

  getScrewsCoords() {
    switch (this.options.formation) {
      case ScrewGroup.formation.FILLED_SQUARE:
      case ScrewGroup.formation.NOT_SET: {
        return this.getSquareScrewCoords(this.options);
      }
      case ScrewGroup.formation.EMPTY_SQUARE: {
        return this.getSquareEdgeScrewCoords(this.options);
      }
      case ScrewGroup.formation.TRIANGLE: {
        return this.getTrianglePanelScrewsCoords(this.options);
      }
      case ScrewGroup.formation.BEND: {
        return this.getBendPanelScrewsCoords();
      }
      case ScrewGroup.formation.ROUNDED_EDGE_QUARE: {
        return this.getSquareRoundedEdgeScrewCoords(this.options);
      }
      case ScrewGroup.formation.CIRCLE:
      default: {
        return this.getCircleCoords(
          this.options.count.n,
          // this.options.padding.diameter,
          this.options.padding.diameter,
          this.options.panel.circleCorrection,
          true
        );
      }
    }
  }

  createScrewCircle(options) {
    const object = new THREE.Object3D();
    const diameter = this.options.padding.diameter / 2;
    const dashMaterial = new THREE.LineDashedMaterial({
      color: 0x000000,
      dashSize: (2 * Math.PI * 2) / 10,
      gapSize: (2 * Math.PI * 2) / 10,
      linewidth: 4,
      depthTest: false
    });
    const circGeom = new THREE.CircleGeometry(diameter, 50);

    // circGeom.vertices.shift();
    
    // VladP: Three.js version was changed and computeLineDistances was removed from geometry
    // circGeom.computeLineDistances();

    // circGeom.toNonIndexed() // adds triangles from origin to each point resulting in 3xpoints
    // first position is the origin, we do not want a line from the origin to the contour line
    let circlePoints = [];
    for (let i = 1; i < circGeom.attributes.position.count; i++){
      circlePoints.push(circGeom.attributes.position.getX(i));
      circlePoints.push(circGeom.attributes.position.getY(i));
      circlePoints.push(circGeom.attributes.position.getZ(i));
    }
    var circleContour = new THREE.BufferGeometry();
    circleContour.setAttribute('position', new THREE.Float32BufferAttribute(circlePoints, 3));

    const circ = new THREE.Line(circleContour, dashMaterial);
    circ.rotation.y = Math.PI / 2;
    circ.position.x = this.options.panel.depth / 2;
    
    if (this.options.panel.dy && this.options.panel.dy.isCustom && this.dyShiftValue){
      circ.position.z += this.dyShiftValue;
    }
    circ.computeLineDistances();

    // this.object.addMesh(circ);
    object.add(circ);

    const { object: line, text: htmlElement } = this.getDiameterLabel(this.options.padding.diameter, circ.position, options);

    // this.object.addMesh(line);
    object.add(line);

    return {
      object,
      htmlElement
    };
  }

  getDiameterLabel(diameter, position, options) {
    const top = {
      from: {
        x: position.x,
        y: position.y - diameter / 2,
        z: position.z
      },
      to: {
        x: position.x,
        y: position.y - diameter / 2,
        z: position.z + diameter / 2 + LabelsPadding
      }
    };
    const bottom = {
      from: {
        x: position.x,
        y: position.y + diameter / 2,
        z: position.z
      },
      to: {
        x: position.x,
        y: position.y + diameter / 2,
        z: position.z + diameter / 2 + LabelsPadding
      }
    };
    
    let text = ((!options || !options.is3DMode || options.showLabels) ? `D = ` : "") +
              `${unitTransform(diameter).from(defaultUnits.DISTANCE).to(Scene.units.distance)}`;
    const D = addDistanceLabel({
      top,
      bottom,
      size: diameter,
      arrowDirection: Arrow.types.direction.Y,
      labelText: text,
      labelValue: unitTransform(diameter)
        .from(defaultUnits.DISTANCE)
        .to(Scene.units.distance),
      align: TextLabel.types.align.CENTER,
      verticalAlign: TextLabel.types.verticalAlign.TOP,
      onChange: value => {
        Scene.onUpdate({
          screw: {
            padding: {
              diameter: unitTransform(+value)
                .from(Scene.units.distance)
                .to(defaultUnits.DISTANCE)
            }
          }
        });
      }
    });
    
    if (options && options.is3DMode) {
      if (!options.displayHorizontally && options.rotation) {
        var startPos = new THREE.Vector3(bottom.to.x, bottom.to.y, bottom.to.z);
        startPos.applyEuler(options.rotation);
        var endPos = new THREE.Vector3(top.to.x, top.to.y, top.to.z);
        endPos.applyEuler(options.rotation);
        D.text.setDirection(startPos, endPos, false);
      }

      D.text.position.z += 20; // add padding
      // D.text.position.y = 0; 
      D.text.position.applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
      D.text.verticalAlign = HTMLEditableLabel.types.verticalAlign.CENTER;
      D.text.align = HTMLEditableLabel.types.align.CENTER;
    }

    return D;
  }

  getSquareScrewCoords({ count, padding, ignoreDy }) {
    const coordinates = [];
    // n = cols, m = rows !!!!
    if (this.options.vertical) {
      const { n, m } = count;
      count.n = m;
      count.m = n;

      const { s1, s2 } = padding;
      padding.s1 = s2;
      padding.s2 = s1;
    }

    let patternOrigin = new THREE.Vector3(0, 0, 0);
    patternOrigin.y = this.position.y + (-((count.n - 1) / 2.0) * padding.s1); // x
    patternOrigin.z = this.position.z + (-((count.m - 1) / 2.0) * padding.s2); // y

    for (let i = 0; i < count.m; i++) {
      for (let j = 0; j < count.n; j++) {
        if (count.ignorePositions && isPositionInArray(i, j, count.ignorePositions)) {
          continue; // eslint-disable-line no-continue
        }

        const position = new THREE.Vector3();

        if (count.toHorizontalMiddle && isPositionInArray(i, j, count.toHorizontalMiddle)) {
          position.y = 0;
        } else {
          position.y = -(patternOrigin.y + padding.s1 * j);
        }

        position.z = -(patternOrigin.z + padding.s2 * i);

        coordinates.push(position);
      }
    }

    if (!ignoreDy && this.options.panel.dy && this.options.panel.dy.isCustom){
      let endpoints = getEndpoints(coordinates);
      let dyShiftValue = -endpoints.bottom.z - this.options.panel.dy.value + this.options.panel.height / 2;
        // ((this.options.panel.dpp && this.options.panel.dpp.active) ? this.options.panel.dpp.value : 0);
      coordinates.forEach((coord) => {
        coord.z += dyShiftValue;
      });
    }
    return coordinates;
  }

  getSquareEdgeScrewCoords({ count, padding }) {
    const coordinates = [];

    for (let n = 0; n < count.n; n++) {
      for (let m = 0; m < count.m; m++) {
        if (squareEdgeCondition(n, m, count)) {
          continue; // eslint-disable-line no-continue
        }

        const position = new THREE.Vector3();

        position.y = (n - (count.n - 1) / 2) * (padding.s1 + this.position.y);
        position.z = (m - (count.m - 1) / 2) * (padding.s2 + this.position.z);

        coordinates.push(position);
      }
    }

    return coordinates;
  }

  getSquareRoundedEdgeScrewCoords({ count, padding }) {
    const coordinates = [];

    for (let n = 0; n < count.n; n++) {
      for (let m = 0; m < count.m; m++) {
        if (squareEdgeCondition(n, m, count) || squareRoundedEdgeCondition(n, m, count)) {
          continue; // eslint-disable-line no-continue
        }

        const position = new THREE.Vector3();

        position.y = (n - (count.n - 1) / 2) * (padding.s1 + this.position.y);
        position.z = (m - (count.m - 1) / 2) * (padding.s2 + this.position.z);

        coordinates.push(position);
      }
    }

    return coordinates;
  }

  getTrianglePanelScrewsCoords({ count, padding }) {
    /*
    if (this.options.customLayout) {
      // For N screws
      if (count.n) {
        const innerTriangle = getInnerTriangleWithSyncCenter.call(
          this,
          this.options.panel.width / (padding.s * (count.n - 1))
        );

        const dots = removeDuplicatesDots([
          ...getDotsOnSide(innerTriangle.A, innerTriangle.B, count.n),
          ...getDotsOnSide(innerTriangle.B, innerTriangle.C, count.n),
          ...getDotsOnSide(innerTriangle.C, innerTriangle.A, count.n)
        ]);

        return dots.map(item => {
          return new THREE.Vector3(0, item.x, item.y);
        });
      }
    } else {
      // For single screw
      if (count.n === 1) {
        // const middle = triangleMiddle(
        //   triangleSides(this.options.panel, new THREE.Vector2(this.position.y, this.position.z))
        // );
        const position = new THREE.Vector3();

        // position.y = middle.x;
        // position.z = middle.y;

        return [position];
      }

      // For two screws
      if (count.n === 2) {
        const innerTriangle = getInnerTriangleWithSyncCenter.call(this, this.options.panel.height / padding.s);

        const firstPosition = new THREE.Vector3();

        firstPosition.y = innerTriangle.A.x;
        firstPosition.z = innerTriangle.A.y;

        const secondPosition = new THREE.Vector3();

        secondPosition.y = innerTriangle.A.x;
        secondPosition.z = innerTriangle.C.y;

        return [firstPosition, secondPosition];
      }

      // For N screws
      if (count.n) {
        const innerTriangle = getInnerTriangleWithSyncCenter.call(this, this.options.panel.width / padding.s);

        const dots = removeDuplicatesDots([
          ...getDotsOnSide(innerTriangle.A, innerTriangle.B, count.n),
          ...getDotsOnSide(innerTriangle.B, innerTriangle.C, count.n),
          ...getDotsOnSide(innerTriangle.C, innerTriangle.A, count.n)
        ]);

        return dots.map(item => {
          return new THREE.Vector3(0, item.x, item.y);
        });
      }
    }
    */
    if (this.options.isSafetyBarrier && 3 === count.n) {
      const coordinates = [];
      const firstPos = new THREE.Vector3();
      firstPos.y -= 0;
      firstPos.z -= -this.options.padding.s2 / 2;
      coordinates.push(firstPos);

      const secondPos = new THREE.Vector3();
      secondPos.y -= this.options.padding.s1 / 2;
      secondPos.z -= this.options.padding.s2 / 2;
      coordinates.push(secondPos);

      const thirdPos = new THREE.Vector3();
      thirdPos.y -= -this.options.padding.s1 / 2;
      thirdPos.z -= this.options.padding.s2 / 2;
      coordinates.push(thirdPos);

      if (this.options.panel.dy && this.options.panel.dy.isCustom){
        let endpoints = getEndpoints(coordinates);
        let dyShiftValue = -endpoints.bottom.z - this.options.panel.dy.value + this.options.panel.height / 2;
        coordinates.forEach((coord) => {
          coord.z += dyShiftValue;
        });
      }
      return coordinates;
    }

    var isCustom = this.options.customLayout || this.options.custom.allow; // editor || input
    if (count.n === 1) {
      const position = new THREE.Vector3();
      return [position];
    } else {
      var triangleHeight = this.options.panel.height;
      var triangleBase = this.options.panel.width;
      var triangleArea = triangleBase * triangleHeight / 2;
      var triangleSide = Math.sqrt(Math.pow(triangleBase / 2, 2) + Math.pow(triangleHeight, 2));
      var triangleInnerCircleRadius = triangleArea / ((2 * triangleSide + triangleBase) / 2);

      var patternTriangleBase = padding.s;
      var patternTriangleInnerCircleRadius = ((patternTriangleBase / 2) * triangleInnerCircleRadius) / (triangleBase / 2);
      var patternTriangleHeight = ((patternTriangleBase / 2) * triangleHeight) / (triangleBase / 2);

      if ((!isCustom && 3 === count.n) || (isCustom && 2 === count.n)) {
        const firstPos = new THREE.Vector3();
        firstPos.y -= -patternTriangleBase / 2;
        firstPos.z -= -patternTriangleInnerCircleRadius;

        const secondPos = new THREE.Vector3();
        secondPos.y -= patternTriangleBase / 2;
        secondPos.z -= -patternTriangleInnerCircleRadius;

        const thirdPos = new THREE.Vector3();
        thirdPos.y -= 0;
        thirdPos.z -= patternTriangleHeight - patternTriangleInnerCircleRadius;

        return [firstPos, secondPos, thirdPos];
      } else {
        if (!isCustom) {
          if (2 === count.n) {
            const firstPos = new THREE.Vector3();
            firstPos.y -= 0;
            firstPos.z -= -triangleInnerCircleRadius + (triangleHeight - padding.s) / 2;
    
            const secondPos = new THREE.Vector3();
            secondPos.y -= 0;
            secondPos.z -= triangleHeight - triangleInnerCircleRadius - (triangleHeight - padding.s) / 2;
    
            return [firstPos, secondPos];
          }
        } else { //custom arrangement, specifies number of anchors on each triangle side
          var edgeSegmentsNum = count.n - 1;
          var slopedEdgeSegLengthX = (patternTriangleBase / 2) / edgeSegmentsNum;
          var slopedEdgeSegLengthY = patternTriangleHeight / edgeSegmentsNum;
          var horizEdgeSegLengthX = patternTriangleBase / edgeSegmentsNum;

          const coordinates = [];
          //bottom side
          for (let jj = 0; jj < count.n; jj++) {
            let pos = new THREE.Vector3();
            pos.y -= (-patternTriangleBase / 2) + (jj * horizEdgeSegLengthX);
            pos.z -= -patternTriangleInnerCircleRadius;
            coordinates.push(pos);
          }
          //right side 
          for (let jj = 0; jj < count.n -2; jj++) {
            let pos = new THREE.Vector3();
            pos.y -= (patternTriangleBase / 2) - ((jj + 1) * slopedEdgeSegLengthX);
            pos.z -= -patternTriangleInnerCircleRadius + ((jj + 1) * slopedEdgeSegLengthY);
            coordinates.push(pos);
          }
          //left side
          for (let jj = 0; jj < count.n -1; jj++) {
            let pos = new THREE.Vector3();
            pos.y -= -(jj * slopedEdgeSegLengthX);
            pos.z -= (patternTriangleHeight - patternTriangleInnerCircleRadius) - (jj * slopedEdgeSegLengthY);
            coordinates.push(pos);
          }

          return coordinates;
        }
      }
    }

    // function getInnerTriangleWithSyncCenter(resizeTo) {
    //   const position = new THREE.Vector2(this.position.y, this.position.z);

    //   let side;
    //   let height;
    //   let resize = resizeTo;

    //   if (this.options.customLayout) {
    //     resize = 1;
    //     side = (count.n - 1) * padding.s;
    //     height = Math.sqrt(Math.pow(side, 2) - Math.pow(side / 2, 2));
    //   } else {
    //     side = this.options.panel.width;
    //     height = this.options.panel.height;
    //   }

    //   const innerTriangle = resizeTriangle(getTriangle(side, height, position), resize);

    //   // Move inner center to parent center
    //   const parentTriangleMiddle = triangleMiddle(triangleSides(this.options.panel, position));
    //   const innerTriangleMiddle = triangleMiddle(innerTriangle);

    //   if (this.options.panel.type === Panel.types.TRIANGLE || this.options.panel.vertices.count === 3) {
    //     const difference = parentTriangleMiddle.y - innerTriangleMiddle.y;

    //     innerTriangle.A.y += difference;
    //     innerTriangle.B.y += difference;
    //     innerTriangle.C.y += difference;
    //   }

    //   return innerTriangle;
    // }
  }

  getBendPanelScrewsCoords() {
    const coordinates = [];

    // Generate coordinates for top panel
    coordinates.push(
      this.getSquareScrewCoords({
        count: {
          n: this.options.forBend.topCount,
          m: 1
        },
        padding: this.options.padding,
        ignoreDy: true
      }).map(coord => { 
        coord.z -= this.options.panel.depth / 2;
        return coord;
      })
    );

    // Generate coordinates for side panel
    coordinates.push(
      this.getSquareScrewCoords({
        count: {
          n: this.options.forBend.sideCount,
          m: 1
        },
        padding: this.options.padding,
        ignoreDy: true
      }).map(coord => { 
        coord.x -= this.options.panel.depth / 2;
        return coord;
      })
    );

    if (this.options.panel.dy && this.options.panel.dy.isCustom){
      let endpoints = getEndpoints(coordinates, true);
      let dyShiftValue = -endpoints.side.bottom.z - this.options.panel.dy.value + this.options.panel.height / 2;
      coordinates[1].forEach((coord) => {
        coord.x -= dyShiftValue;
      });
    }

    return coordinates;
  }

  // VladP: Width/Height for circle?
  // getCircleCoords(count, width, height, correction = 0, isInner = false) {
  getCircleCoords(count, diameter, correction = 0, isInner = false) {
    const coordinates = [];

    var patternXDir = new THREE.Vector3(1, 0, 0);
    var patternZDir = new THREE.Vector3(0, 0, 1);
    if (count > 1) {
      var angle = 2.0 * Math.PI / count;
      if ((2 === count) || (1 === (count % 2))) { //2 anchors or odd number ?
        let rotMat = new THREE.Matrix4();
        rotMat.makeTranslation(this.position.x, this.position.y, this.position.z);
        rotMat.makeRotationAxis(patternZDir, Math.PI / 2.0);
        patternXDir.applyMatrix4(rotMat);
      } else { // > 3
        let rotMat = new THREE.Matrix4();
        rotMat.makeTranslation(this.position.x, this.position.y, this.position.z);
        rotMat.makeRotationAxis(patternZDir, angle / 2.0);
        patternXDir.applyMatrix4(rotMat);
      }
      if (this.options.isSafetyBarrier) {
        if (2 === count) {
          let rotMat = new THREE.Matrix4();
          rotMat.makeTranslation(this.position.x, this.position.y, this.position.z);
          rotMat.makeRotationAxis(patternZDir, Math.PI / 2.0);
          patternXDir.applyMatrix4(rotMat);
        } else {
          let rotMat = new THREE.Matrix4();
          rotMat.makeTranslation(this.position.x, this.position.y, this.position.z);
          rotMat.makeRotationAxis(patternZDir, Math.PI);
          patternXDir.applyMatrix4(rotMat);
        }
      }

      patternXDir.multiplyScalar(diameter / 2);
      var rotMatEach = new THREE.Matrix4();
      rotMatEach.makeTranslation(this.position.x, this.position.y, this.position.z);
      rotMatEach.makeRotationAxis(patternZDir, angle);

      for (let i = 0; i < count; i++) {
        var position = new THREE.Vector3();
        position.y = -(this.position.x + patternXDir.x);
        position.z = -(this.position.y + patternXDir.y);
        patternXDir.applyMatrix4(rotMatEach);
        coordinates.push(position);
      }
    } else {
      coordinates.push(new THREE.Vector3());
    }

    if (this.options.panel.dy && this.options.panel.dy.isCustom){
      let endpoints = getEndpoints(coordinates);
      this.dyShiftValue = -endpoints.bottom.z - this.options.panel.dy.value + this.options.panel.width / 2;
      coordinates.forEach((coord) => {
        coord.z += this.dyShiftValue;
      });
    }
    return coordinates;
  }

  // Labels
  createDyLabel(startX, options) {
    //var bottomScrewPosition;
    var leftScrewPosition;
    if (this.options.panel.type === Panel.types.BEND && 
      Array.isArray(this.screwCoordinates[0]) && 
      Array.isArray(this.screwCoordinates[1])) {
      let endPoints = getEndpoints(this.screwCoordinates, true);
      //bottomScrewPosition = endPoints.side.bottom;
      leftScrewPosition = endPoints.side.left;
    }
    else {
      let endPoints = getEndpoints(this.screwCoordinates, false);
      //bottomScrewPosition = endPoints.bottom;
      leftScrewPosition = endPoints.left;
    }
    const padding = LabelsPadding;

    const position = {
      x: 0,
      // y: leftScrewPosition.y + padding,
      y: (startX || this.options.panel.width / 2) + padding,
      z: this.options.panel.height / 2
    };
    if (this.options.panel.type === Panel.types.CIRCLE)
      position.z = this.options.panel.width / 2;
    else if (this.options.panel.type === Panel.types.BEND) {
      position.x += this.options.panel.depth / 2;
      position.z += this.options.panel.depth / 2;
    }

    var dyArrow = new THREE.Object3D();
    const arrow = new Arrow({
      position,
      size: -this.options.panel.dy.value,
      direction: Arrow.types.direction.Z,
      disableDepthTest: true
    });
    dyArrow.add(arrow.mesh);

    const topLine = new Line({
      from: {
        x: position.x,
        y: leftScrewPosition.y,
        z: position.z - this.options.panel.dy.value
      },
      to: {
        x: position.x,
        y: (startX ? 0 : this.options.panel.width / 2) + padding,
        z: position.z - this.options.panel.dy.value
      },
      disableDepthTest: true
    });
    dyArrow.add(topLine.mesh);

    const bottomLine = new Line({
      from: {
        x: position.x,
        y: startX || this.options.panel.width / 2,
        z: position.z
      },
      to: {
        x: position.x,
        y: (startX || this.options.panel.width / 2) + padding,
        z: position.z
      },
      disableDepthTest: true
    });
    dyArrow.add(bottomLine.mesh);

    if (this.options.panel.type === Panel.types.BEND) {
      dyArrow.rotation.y = Math.PI / -2;
      dyArrow.rotation.x = Math.PI;
    }
    this.object.addMesh(dyArrow);

    const htmlElement = new HTMLEditableLabel({
      text: ((!options || !options.is3DMode || options.showLabels) ? `Dy = ` : '') + 
        `${unitTransform(+this.options.panel.dy.value).from(defaultUnits.DISTANCE).to(Scene.units.distance)}`,
      value: unitTransform(+this.options.panel.dy.value).from(defaultUnits.DISTANCE).to(Scene.units.distance),
      align: HTMLEditableLabel.types.align.RIGHT,
      verticalAlign: HTMLEditableLabel.types.verticalAlign.CENTER,
      minValue: 0
    });
    htmlElement.onInputChange((value, didChange) => {
      this.dispatchOptionUpdate({
        panel: {
          dy: {
            value: unitTransform(+value)
              .from(Scene.units.distance)
              .to(defaultUnits.DISTANCE),
            isCustom: true
          }
        }
      },
      false,
      didChange);
    });

    return {
      arrow,
      arrowGroup: dyArrow,
      htmlElement
    };
  }

  createSLabel(groundPadding, options) {
    if (this.options.formation === ScrewGroup.formation.TRIANGLE && !this.options.customLayout) {
      if (this.screwCoordinates.length > 1) {
        let first;
        let second;
        let isVertical = this.screwCoordinates.length === 2;

        if (this.screwCoordinates.length === 2) {
          [first, second] = this.screwCoordinates;
        } else {
          const firstIndex = 0; // this.options.count.n - 1;
          const lastIndex = this.options.custom.allow ? (this.options.count.n - 1) : (this.options.count.n - 2); // !allow = 1 always
          //this.screwCoordinates.length - this.options.count.n + 1;

          first = this.screwCoordinates[firstIndex];
          second = this.screwCoordinates[lastIndex];
        }

        let offset = this.options.heightType === Screw.types.height.INDENTED ? -this.options.panel.standOff.value / 2 : 0;
        const top = {
          from: {
            x: -first.x +1 + offset,
            y: first.y,
            z: first.z
          },
          to: {
            x: -first.x +1 + offset,
            y: isVertical ? LabelsPadding + groundPadding.right : first.y,
            z: isVertical ? first.z : LabelsPadding + groundPadding.top
          }
        };
        const bottom = {
          from: {
            x: -first.x +1 + offset,
            y: second.y,
            z: second.z
          },
          to: {
            x: -first.x +1 + offset,
            y: isVertical ? LabelsPadding + groundPadding.right : second.y,
            z: isVertical ? second.z : LabelsPadding + groundPadding.top
          }
        };

        let text = ((!options || !options.is3DMode || options.showLabels) ? `S = ` : "") +
                  `${unitTransform(this.options.padding.s).from(defaultUnits.DISTANCE).to(Scene.units.distance)}`;
        const S = addDistanceLabel({
          top,
          bottom,
          size: isVertical ? second.z - first.z : second.y - first.y,
          arrowDirection: isVertical ? Arrow.types.direction.Z : Arrow.types.direction.Y,
          labelText: text,
          labelValue: unitTransform(this.options.padding.s)
            .from(defaultUnits.DISTANCE)
            .to(Scene.units.distance),
          align: isVertical ? HTMLEditableLabel.types.align.RIGHT : HTMLEditableLabel.types.align.CENTER,
          verticalAlign: isVertical
            ? HTMLEditableLabel.types.verticalAlign.CENTER
            : HTMLEditableLabel.types.verticalAlign.TOP,
          onChange: setPaddingS
        });

        if (options && options.is3DMode) {
          if (!options.displayHorizontally && options.rotation) {
            var startPos = new THREE.Vector3(bottom.to.x, bottom.to.y, bottom.to.z);
            startPos.applyEuler(options.rotation);
            var endPos = new THREE.Vector3(top.to.x, top.to.y, top.to.z);
            endPos.applyEuler(options.rotation);
            S.text.setDirection(startPos, endPos, false);
          }
          if (isVertical)
            S.text.position.x -= 20; // add padding
          else 
            S.text.position.z += 20; // add padding

          S.text.position.applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
          S.text.verticalAlign = HTMLEditableLabel.types.verticalAlign.CENTER;
          S.text.align = HTMLEditableLabel.types.align.CENTER;
        }

        return {
          object: S.object,
          htmlElement: S.text || null
        };
      }
    }
  }
  
  getScrewLabels(allowDrag){
    var labels; 
    if (allowDrag) 
      labels = [];
    else 
      labels = new AbstractObject();

    let screws = [];
    if (this.screwCoordinates.length > 1 && Array.isArray(this.screwCoordinates[1]))
      screws = this.screwCoordinates[1];
    else 
      screws = this.screwCoordinates;
    this.screws.forEach((screw) => {
      if (screws.some((s) => 
        screw.position.x - (screw.options.heightOffset || 0) / 2 === s.x && 
        screw.position.y === s.y &&
        screw.position.z === s.z)) 
      {
        if (allowDrag) {
          labels.push(new DraggableObject({ mesh: screw.screw, htmlObject: screw.numberLabel }));
        } else {
          labels.htmlLayer.add(screw.numberLabel);
        }
      }
    });

    return labels;
  }

}

function isPositionInArray(n, m, positionList) {
  for (let i = 0; i < positionList.length; i++) {
    if (positionList[i].n === n + 1 && positionList[i].m === m + 1) {
      return true;
    }
  }

  return false;
}

function setScrewPositions(pos) {
  Scene.onUpdate(
    {
      screw: {
        coordinatesList: pos
      }
    },
    true
  );
}

export function setScrewCustomPositions(pos, ignoreObjectUpdate) {
  Scene.onUpdate(
    {
      screw: {
        custom: {
          active: true,
          positions: pos
        }
      }
    },
    ignoreObjectUpdate
  );
}

function setPaddingS(value) {
  Scene.onUpdate(
    {
      screw: {
        padding: {
          s: unitTransform(+value)
            .from(Scene.units.distance)
            .to(defaultUnits.DISTANCE)
        }
      }
    },
    false
  );
}

function squareEdgeCondition(n, m, count) {
  return m > 0 && n !== 0 && (m < count.m - 1 && n !== count.n - 1);
}

function squareRoundedEdgeCondition(n, m, count) {
  return (
    (n === 0 && m === 0) ||
    (n === count.n - 1 && m === count.m - 1) ||
    (n === count.n - 1 && m === 0) ||
    (n === 0 && m === count.m - 1)
  );
}



// WEBPACK FOOTER //
// ./src/object-view/objects/screw/screw-group.js